import React from 'react';
export const Quotes = () => {
  return <div className="py-16 bg-gray-50 relative" data-id="element-118">
      {/* Stars and stripes background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-119">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-120"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-121">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-122">
          <span className="text-blue-700 mr-2" data-id="element-123">★</span>
          Quotes that made headlines
          <span className="text-red-700 ml-2" data-id="element-124">★</span>
        </h2>
        <p className="text-lg text-gray-700 mb-8" data-id="element-125">
          Kirk mastered the art of short, powerful statements that championed
          American values—perfect for the viral age:
        </p>
        <div className="grid gap-6 md:grid-cols-1 mb-12" data-id="element-126">
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-700" data-id="element-127">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-128">
              "Freedom is not free. It comes with responsibility and sacrifice."
            </blockquote>
            <div className="flex justify-end" data-id="element-129">
              <div className="w-8 h-2 bg-blue-700" data-id="element-130"></div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-white border-r-4 border-r-blue-700" data-id="element-131">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-132">
              "If you win the classroom, you win the culture. If you win the
              culture, you win the nation."
            </blockquote>
            <div className="flex justify-end" data-id="element-133">
              <div className="w-8 h-2 bg-red-700" data-id="element-134"></div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-blue-700" data-id="element-135">
            <blockquote className="text-xl italic font-medium text-gray-800 mb-4" data-id="element-136">
              "Without God, the state becomes God. And that's the path to
              tyranny."
            </blockquote>
            <div className="flex justify-end" data-id="element-137">
              <div className="w-8 h-2 bg-red-700" data-id="element-138"></div>
            </div>
          </div>
        </div>
        <p className="text-lg text-gray-700 font-medium text-center" data-id="element-139">
          These aren't just words. They're battle cries for America's future.
        </p>
      </div>
    </div>;
};